<div class="fx-row align-items-center justify-content-start document-case-score-container"
  [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="tooltip()">
  <div class="score" [style.flex-basis.%]="100*score">
  </div>
</div>